import React from "react";
import ReactDOM from "react-dom";
import Header from "../components/Header/Header";
import nameOfSearch from "../constants/nameOfSearch";

// TODO rebuild to real data.
const navigationBlock = window.drupalSettings?.navigation || {};
const themeHeader = window.drupalSettings?.themeHeader || "white";
const { getStockData } = window.drupalSettings;
const languageDirection = window.drupalSettings?.language?.direction || "ltr";
const mainSiteLink = window.drupalSettings?.mainSiteLink || null;
const typeOfMenu = window.drupalSettings?.typeOfMenu || "default";
const showStockData = window.drupalSettings?.showStock;

export default function HeaderContainer() {
  return ReactDOM.createPortal(
    <Header
      navigationBlock={navigationBlock}
      themeHeader={themeHeader}
      getStockData={getStockData}
      showStockData={showStockData}
      languageDirection={languageDirection}
      typeOfSearch={nameOfSearch.global}
      linkToSite={mainSiteLink}
      typeOfMenu={typeOfMenu}
    />,
    document.getElementById("HeaderComponent")
  );
}
